export function validateEmail(email?: string) {
  if (!email) return 'E-mail é obrigatório';

  return !email.trim() || /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)
    ? true
    : 'E-mail inválido';
}
